// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Icon$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as PlaceOrderContext from "../context/PlaceOrderContext.bs.js";
import * as PlaceOrderGaConfig from "../../app/helper/PlaceOrderGaConfig.bs.js";

function Header(Props) {
  var onCloseClick = Props.onCloseClick;
  var match = PlaceOrderContext.useContext(undefined).state;
  var customerInfo = match.customerInfo;
  var currentStep = match.currentStep;
  var match$1 = CountryContext.useContext(undefined);
  var country = match$1.country;
  return React.createElement("div", {
              className: "header__container"
            }, React.createElement("p", {
                  className: "title"
                }, "Place Order"), React.createElement("button", {
                  className: "close-button",
                  onClick: (function (param) {
                      PlaceOrderGaConfig.publishEvent({
                            category: currentStep + 1 | 0,
                            action: "Close Modal",
                            label: "1_" + customerInfo.mobile,
                            value: undefined,
                            nonInteraction: undefined
                          }, country);
                      return Curry._1(onCloseClick, undefined);
                    })
                }, React.createElement(Icon$Catalyst.CloseIcon.make, {})));
}

var make = Header;

export {
  make ,
  
}
/* react Not a pure module */
